import React from "react";
import { Box, Grid, Typography, Card, CardContent, Container } from "@mui/material";

const features = [
  {
    icon: "/Images/cardblue.png",
    title: "Instant withdrawals",
    description:
      "Stay in control of your money: select your preferred payment method, request a withdrawal, and receive instant, automatic approval.",
  },
  {
    icon: "/Images/cardBring.png",
    title: "Ultra-fast execution",
    description:
      "Anticipate every move with ultra-fast execution—your orders filled in milliseconds across all BBCorp platforms.",
  },
  {
    icon: "/Images/cardYellow.png",
    title: "Stop Out Protection",
    description:
      "Outpace the market with lightning-fast execution—orders completed in milliseconds across every BBCorp platform.",
  },
];

const MTCorp = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#fff" }}>
      <Container maxWidth="lg">
        {/* Centered heading and description */}
        <Box textAlign="center" mb={6}>
          <Typography variant="h2">
          Why BBCorp?
          </Typography>
          <Typography
            sx={{
                fontSize: { xs: "20px", md: "22px" },
                color: "rgba(102, 112, 133, 1)",
                fontWeight: 400,
                mt: 4,
              }}
          >
            BBCorp offers world-class financial infrastructure designed for speed,
            reliability, and unmatched protection to empower your trading journey.
          </Typography>
        </Box>

        {/* Feature cards */}
        <Grid container spacing={4} justifyContent="center">
          {features.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  textAlign: "center",
                  // backgroundColor: "#F6F9FC",
                  background: "rgba(246, 249, 252, 1)",

                  px: 3,
                  py: 5,
                }}
              >
                <CardContent>
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.title}
                    sx={{ width: 80, height: 110, mb: 3, mx: "auto" }}
                  />
                  <Typography variant="h4" fontWeight={600}>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="#607085"
                    sx={{ maxWidth: 280, mx: "auto",mt:2,fontWeight:"500"}}
                  >
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MTCorp;
